import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";

import rootReducer from "./rootReducer";
import AddSearchApiSlice from "../features/addSearchApiSlice";
import IoBaseApiSlice from "../features/io/ioBaseApiSlice";
import NetlifyApiSlice from "../features/netlifyApiSlice";

export type RootState = ReturnType<typeof rootReducer>

export const store = configureStore({
  middleware: (getDefaultMiddleware) => (
    // see: https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
    // see: https://github.com/reduxjs/redux-toolkit/issues/415
    getDefaultMiddleware({ immutableCheck: false, serializableCheck: false })
      .concat([
        NetlifyApiSlice.middleware,
        AddSearchApiSlice.middleware,
        IoBaseApiSlice.middleware,
      ])
  ),
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
